import React from "react";
import "./SummaryCards.scss";

const normalizeItem = (item) =>
  Array.isArray(item)
    ? {
        icon: item[0],
        tone: item[1],
        label: item[2],
        value: item[3],
        note: item[4],
      }
    : item;

const SummaryCards = ({
  items = [],
  ariaLabel = "Page summary",
  className = "",
  columns = 5,
  variant,
  dataAttributes = {},
}) => (
  <section
    className={`summary-cards${variant ? ` summary-cards--${variant}` : ""}${className ? ` ${className}` : ""}`}
    aria-label={ariaLabel}
    style={{ "--summary-card-columns": columns }}
    {...dataAttributes}
  >
    {items.map((entry) => {
      const item = normalizeItem(entry);
      const Card = item.onClick ? "button" : "article";
      return (
        <Card
          className={`summary-card${
            item.className ? ` ${item.className}` : ""
          }`}
          key={item.key || item.label}
          type={item.onClick ? "button" : undefined}
          onClick={item.onClick}
          aria-pressed={
            item.onClick && item.active !== undefined ? item.active : undefined
          }
        >
          <i
            className={`bx ${
              item.icon
            } summary-card__icon summary-card__icon--${item.tone || "blue"}`}
            aria-hidden="true"
          />
          <div className="summary-card__value">
            <span>{item.label}</span>
            <strong>{item.value}</strong>
            {variant === "action" && item.note != null && <small>{item.note}</small>}
          </div>
          {variant !== "action" && item.note !== undefined && item.note !== null && (
            <small>{item.note}</small>
          )}
          {variant === "action" && item.onClick && (
            <i className="bx bx-chevron-right summary-card__chevron" aria-hidden="true" />
          )}
        </Card>
      );
    })}
  </section>
);

export default SummaryCards;
